// import _ from 'lodash';
import React from 'react';
import { UseFormMethods } from 'react-hook-form';

interface IRHFInputBoxProps extends Partial<Pick<UseFormMethods, 'register' | 'errors'>> {
    label?: string;
    labelOnLeft?: boolean;
    labelStyle?: React.CSSProperties;
    title?: string;
    isRequired?: boolean;
    disabled?: boolean;
    readOnly?: boolean;
    name: string;
    placeholder?: string;
    type?: 'text' | 'date' | 'number' | 'hidden' | 'file';
    rules?: unknown;
    onClick?: (event?: React.MouseEvent<HTMLInputElement>) => void;
    onDoubleClick?: (event?: React.MouseEvent<HTMLInputElement>) => void;
    onChange?: (event?: React.FormEvent<HTMLInputElement>) => void;
    onBlur?: (event?: React.FormEvent<HTMLInputElement>) => void;
    onEnterPressed?: (event: React.KeyboardEvent<HTMLInputElement>) => void;
    onFocus?: (event: React.FocusEvent<HTMLInputElement>) => void;
    onPaste?: (event: React.ClipboardEvent<HTMLInputElement>) => void;
    style?: React.CSSProperties;
    className?: string;
    bodyClassName?: string;
    step?: number;
    max?: number;
    min?: number;
    bodyStyle?: React.CSSProperties;
    defaultVal?: string;
    id?: string;
}

// const RHFInputBox: React.FC<IRHFInputBoxProps> = props => {
const RHFInputBox = (props: IRHFInputBoxProps) => {

    if (props.labelOnLeft) {
        return (
            <div className={!!props?.bodyClassName ? props.bodyClassName : 'form-field'} style={props.bodyStyle}>
                { props.label && <div className="form-row">
                    <label htmlFor={props.name} style={{marginRight: '1rem', ...props.labelStyle}}>
                        { props.label }
                        {!!props.isRequired && <span style={{ color: 'red' }}>*</span>}
                    </label>
                    <input
                        id={props?.id !== null && props?.id !== undefined ? props?.id : ''}
                        name={props.name}
                        ref={props.register ? props.register(props.rules) : undefined}
                        type={props.type || 'text'}
                        className={`field ${props.name.split('.')?.reduce((o, i) => o?.[i], props.errors) ? 'error-field' : ''}`}
                        max={props.max}
                        min={props.min}
                        onClick={props?.onClick}
                        onDoubleClick={props?.onDoubleClick}
                        onChange={props?.onChange}
                        onBlur={props?.onBlur}
                        onFocus={props?.onFocus}
                        onPaste={props?.onPaste}
                        disabled={props.disabled}
                        style={!!props.disabled ? { cursor: 'not-allowed', marginLeft: '1rem', ...props.style} : props.style}
                        step={props.step ? props.step : undefined}
                        defaultValue={props.defaultVal}
                        placeholder={props.placeholder}
                        onKeyDown={(e) => e.key === 'Enter' ? props.onEnterPressed : {}}
                        title={props.title}
                        readOnly={props.readOnly}
                    />
                </div>}
                {props.name.split('.')?.reduce((o, i) => o?.[i], props.errors) && (
                    <p style={{color: 'red', marginLeft: '2px'}}>{props.name.split('.')?.reduce((o, i) => o[i], props.errors)?.message}</p>
                )}
            </div>
        );
    } else {
        return (
            <div className="form-field" style={props.bodyStyle}>
                { props.label && <label htmlFor={props.name}>
                    {props.label}
                    {!!props.isRequired && <span style={{ color: 'red' }}>*</span>}
                </label>}
                {props.label && props.label && <br />}
                <input
                    id={props?.id !== null && props?.id !== undefined ? props?.id : ''}
                    name={props.name}
                    ref={props.register ? props.register(props.rules) : undefined}
                    type={props.type || 'text'}
                    className={`field ${props.name.split('.')?.reduce((o, i) => o?.[i], props.errors) ? 'error-field' : ''}`}
                    max={props.max}
                    min={props.min}
                    onClick={props?.onClick}
                    onDoubleClick={props?.onDoubleClick}
                    onChange={props?.onChange}
                    onBlur={props?.onBlur}
                    onFocus={props?.onFocus}
                    onPaste={props?.onPaste}
                    disabled={props.disabled}
                    style={!!props.disabled ? { cursor: 'not-allowed', ...props.style} : props.style}
                    step={props.step ? props.step : undefined}
                    defaultValue={props.defaultVal}
                    placeholder={props.placeholder}
                    onKeyDown={(e) => e.key === 'Enter' ? props.onEnterPressed : {}}
                    title={props.title}
                    readOnly={props.readOnly}
                />
                <br />
                {props.name.split('.')?.reduce((o, i) => o?.[i], props.errors) && (
                    <p>{props.name.split('.')?.reduce((o, i) => o[i], props.errors)?.message}</p>
                )}
            </div>
        );
    }
};

export default RHFInputBox;



// WEBPACK FOOTER //
// ./src/components/controls/tempRHFControls/RHFInputBox.tsx